import React from "react";


const Cv: React.FC = () => <div style={{ margin: 20 }}>Cv</div>

export default Cv;